import classNames from 'classnames'

import s from './ConfiguratorButton.module.scss'
import CaretDownSVG from '../../../assets/CaretDown.svg'

interface ConfiguratorButtonProps {
  direction: string
  onSelect: () => void
  disabled?: boolean
}

export const ConfiguratorButton = ({
  direction,
  onSelect,
  disabled = false,
}: ConfiguratorButtonProps): JSX.Element => {
  return (
    <div
      className={classNames(s.ConfiguratorButton, disabled && s.disabled)}
      onClick={() => !disabled && onSelect()}
    >
      <div className={classNames(s.nav_button, direction === 'right' ? s.right : s.left)}>
        <img src={CaretDownSVG} />
      </div>
    </div>
  )
}
